/**
 * External Dependencies
 */
import 'jquery';

/**
 * Theme Dependencies
 */
import Header from './components/Header';

/**
 * DOM ready
 */
$(document).ready(() => {
  new Header();

  $('.back-to-top').click((e) => {
    e.preventDefault();

    window.scrollTo(0, 0);
  });
});
